<p>doação works!</p>
<div class="class">
    <p>Two way data binding</p>
    <form>
        <input type="text" [(ngModel)]="name" name="name" 
            placeholder="Digite o valor a ser doado" mask="0.0"  decimal="," />
        <input type="submit" value="Enviar" />
    </form>
    <div *ngIf="name !== ''">
        <p>O nome é: {{name}}</p>
    </div>
</div>




